import moment from 'moment';

export const STORAGE = {
    "SCHEDULE" : "schedule"    
}    


class StorageHelperClass {
    del = (type = STORAGE.SCHEDULE) => {
        localStorage.removeItem(type);
    }

    get = (type = STORAGE.SCHEDULE) => {
        let retVal = null;
        let data = localStorage.getItem(type);
        if(data) {
            retVal = JSON.parse(data);
        }
        return retVal;
    }

    set = (type = STORAGE.SCHEDULE, val) => {
        let res = localStorage.setItem(type, JSON.stringify(val));
        return res;
    }
    
}

export default new StorageHelperClass();